import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Box, Slider } from '@mui/material';
import { setCurrentTime, setBooleanState } from '../../../features/videoPlayer/videoPlayer.slice';
import { formatTime } from '../utils/videoPlayerUtils';
import { useNavigate } from 'react-router-dom';

const BottomPlayerButtons = ({videoRef}) => {

    const hovering = useSelector((state) => state.videoPlayer.hovering);
    const isBuffering = useSelector((state) => state.videoPlayer.isBuffering);
    const currentTime = useSelector((state) => state.videoPlayer.currentTime);
    const totalDuration = useSelector((state) => state.videoPlayer.totalDuration);
    const currentVideoPosition = useSelector((state) => state.videoPlayer.currentVideoPosition);
    const flattenedCourse = useSelector((state) => state.videoPlayer.flattenedCourse);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handlePreviousLessonButton = () => {
        if (currentVideoPosition !== null && currentVideoPosition > 0) {
            const previousVideoId = flattenedCourse[currentVideoPosition - 1].id;
            const previousVideoUrl = window.location.pathname.split('/').slice(0, -1).join('/') + `/${previousVideoId}`;
  
            navigate(previousVideoUrl);
        }
    };
  
    const handleNextLessonButton = () => {
        if (currentVideoPosition !== null && currentVideoPosition < flattenedCourse.length - 1) {
            const nextVideoId = flattenedCourse[currentVideoPosition + 1].id;
            const nextVideoUrl = window.location.pathname.split('/').slice(0, -1).join('/') + `/${nextVideoId}`;
    
            navigate(nextVideoUrl);
        }
    };

  return (
    <div>
      {hovering && !isBuffering && (
        <div
          style={{
            position: 'absolute',
            bottom: '15px',
            left: '30px',
            right: '30px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#fff',
            zIndex: 2,
          }}
        >
          <div
            id='lesson-button'
            className='d-flex flex-row gap-2 '
            onClick={() => handlePreviousLessonButton()}
            style={{ cursor: currentVideoPosition !== null && currentVideoPosition > 0 ? 'pointer' : 'default' }}  
          >
            <FontAwesomeIcon icon={faChevronLeft} style={{ paddingTop: '5px' }} />
            <p className='d-none d-md-block' style={{ color: '#fff', fontWeight: '400' }}>Prev Lesson</p>
            <p className='d-block d-md-none' style={{ color: '#fff', fontWeight: '400' }}>Prev</p>
          </div>
          <p style={{ color: '#fff', fontWeight: '400' }}>
            {formatTime(currentTime)}/{formatTime(totalDuration)}
          </p>
          <div 
            id='lesson-button'
            className='d-flex flex-row gap-2 '
            onClick={() => handleNextLessonButton()}
            style={{ cursor: currentVideoPosition !== null && currentVideoPosition < flattenedCourse.length - 1 ? 'pointer' : 'default' }}  
          >
            <p className='d-none d-md-block' style={{ color: '#fff', fontWeight: '400' }}>Next Lesson</p>
            <p className='d-block d-md-none' style={{ color: '#fff', fontWeight: '400' }}>Next</p>
            <FontAwesomeIcon icon={faChevronRight} style={{ paddingTop: '5px' }} />
          </div>
        </div>
      )}

      {hovering && !isBuffering && (
        <div
          id='progress-bar'
          style={{
            position: 'absolute',
            bottom: '35px',
            left: '30px',
            right: '30px',
            zIndex: 2,
          }}
        >
          <Box sx={{ width: '100%' }}>
            <Slider
              value={(currentTime / totalDuration) * 100 || 0}
              onChange={(e, newValue) => {
                const newTime = (newValue / 100) * totalDuration;
                dispatch(setCurrentTime(newTime)); // Update Redux state during dragging
                dispatch(setBooleanState({ key: 'isInteracting', value: true }));
              }}
              onChangeCommitted={(e, newValue) => {
                const video = videoRef.current;
                const newTime = (newValue / 100) * totalDuration;
                video.currentTime = newTime; // Update video time only when the user releases the thumb
              }}
              onTouchStart={() => dispatch(setBooleanState({ key: 'isInteracting', value: true })) }
              onTouchEnd={() => dispatch(setBooleanState({ key: 'isInteracting', value: false }))}
              color='white'
              aria-label="Video Progress"
              valueLabelDisplay="auto"
              valueLabelFormat={(value) =>
                formatTime((value / 100) * totalDuration)
              }
              sx={{
                '& .MuiSlider-thumb': {
                  width: 12, // Adjust the width of the circle
                  height: 12, // Adjust the height of the circle
                },
                '& .MuiSlider-valueLabel': {
                  color: '#fff',
                },
                '& .MuiSlider-track': {
                  backgroundColor: '#fff',
                },
                '& .MuiSlider-rail': {
                  backgroundColor: '#888',
                },
              }}
            />
          </Box>
        </div>
      )}
    </div>
  )
}

export default BottomPlayerButtons